import { isAxiosError } from "axios";

import { getMessage } from "@/utils/message";

/**
 * Mã lỗi (MSGxx) do backend trả về, đọc an toàn với mọi shape response.
 * Trả về undefined khi không phải lỗi API hoặc response không có mã lỗi.
 */
export const getErrorCode = (error: unknown): string | undefined => {
  if (!isAxiosError(error)) return undefined;

  const data = error.response?.data;
  if (data?.errorCode === "InvalidOTP") return "MSG_TK7";

  return data?.errors?.[0];
};

/**
 * Kiểm tra backend có trả về một mã lỗi cụ thể hay không (vd "MSG2").
 * An toàn khi response không có mảng errors.
 */
export const hasErrorCode = (error: unknown, code: string): boolean => {
  if (!isAxiosError(error)) return false;

  // eslint-disable-next-line no-restricted-syntax -- đây là nơi duy nhất được phép đọc data.errors
  const errors = error.response?.data?.errors;
  return Array.isArray(errors) && errors.includes(code);
};

/**
 * Câu thông báo tiếng Việt hiển thị cho người dùng.
 * Luôn trả về chuỗi có nghĩa và không bao giờ ném lỗi.
 */
export const getErrorMessage = (error: unknown): string =>
  getMessage(getErrorCode(error) ?? "MSG12");

/**
 * Ghi log lỗi kèm ngữ cảnh để truy được nguyên nhân từ DevTools.
 * `context` nên là "TênComponent.tênHàm" của nơi bắt lỗi.
 */
export const logError = (context: string, error: unknown): void => {
  if (isAxiosError(error)) {
    const method = error.config?.method?.toUpperCase();
    console.error(
      `[${context}] ${method} ${error.config?.url} → ${error.response?.status}`,
      {
        code: getErrorCode(error),
        body: error.response?.data,
        error,
      }
    );
    return;
  }

  console.error(`[${context}]`, error);
};
